import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/context/ThemeContext";
import { AuthProvider } from "@/context/AuthContext";
import { BranchProvider } from "@/context/BranchContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Products from "@/pages/Products";
import Inventory from "@/pages/Inventory";
import POS from "@/pages/POS";
import Orders from "@/pages/Orders";
import Transfers from "@/pages/Transfers";
import Stocktake from "@/pages/Stocktake";
import Adjustments from "@/pages/Adjustments";
import NearExpiry from "@/pages/NearExpiry";
import Suppliers from "@/pages/Suppliers";
import Procurement from "@/pages/Procurement";
import Returns from "@/pages/Returns";
import Claims from "@/pages/Claims";
import Schemes from "@/pages/Schemes";
import Statements from "@/pages/Statements";
import Deliveries from "@/pages/Deliveries";
import RiderView from "@/pages/RiderView";
import Prescriptions from "@/pages/Prescriptions";
import TrackDelivery from "@/pages/TrackDelivery";
import Customers from "@/pages/Customers";
import Users from "@/pages/Users";
import Branches from "@/pages/Branches";
import Settings from "@/pages/Settings";
import Audit from "@/pages/Audit";
import Ledger from "@/pages/Ledger";
import Analytics from "@/pages/Analytics";
import CustomerReturns from "@/pages/CustomerReturns";
import LiveMapPage from "@/pages/LiveMapPage";
import Proforma from "@/pages/Proforma";
import Reports from "@/pages/Reports";
import MissedSales from "@/pages/MissedSales";
import WarehouseDaily from "@/pages/WarehouseDaily";
import ShiftOversight from "@/pages/ShiftOversight";
import Inpatients from "@/pages/Inpatients";
import Help from "@/pages/Help";
import Wholesale from "@/pages/Wholesale";
import WholesaleReports from "@/pages/WholesaleReports";

function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
      <BrowserRouter>
        <BranchProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/track/:token" element={<TrackDelivery />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<ProtectedRoute perm="dashboard.view"><Dashboard /></ProtectedRoute>} />
              <Route path="analytics" element={<ProtectedRoute perm="analytics.view"><Analytics /></ProtectedRoute>} />
              <Route path="missed-sales" element={<ProtectedRoute perm="missed_sales.view"><MissedSales /></ProtectedRoute>} />
              <Route path="reports" element={<ProtectedRoute anyPerm={["reports.all", "reports.branch", "reports.delivery"]}><Reports /></ProtectedRoute>} />
              <Route path="pos" element={<ProtectedRoute perm="pos.sell"><POS /></ProtectedRoute>} />
              <Route path="orders" element={<ProtectedRoute perm="sales.view"><Orders /></ProtectedRoute>} />
              <Route path="proforma" element={<ProtectedRoute perm="proforma.view"><Proforma /></ProtectedRoute>} />
              <Route path="customer-returns" element={<ProtectedRoute perm="sales.returns"><CustomerReturns /></ProtectedRoute>} />
              <Route path="products" element={<ProtectedRoute perm="products.view"><Products /></ProtectedRoute>} />
              <Route path="inventory" element={<ProtectedRoute perm="inventory.view"><Inventory /></ProtectedRoute>} />
              <Route path="transfers" element={<ProtectedRoute perm="transfers.view"><Transfers /></ProtectedRoute>} />
              <Route path="stocktake" element={<ProtectedRoute perm="stocktake.view"><Stocktake /></ProtectedRoute>} />
              <Route path="adjustments" element={<ProtectedRoute perm="adjustments.view"><Adjustments /></ProtectedRoute>} />
              <Route path="warehouse-daily" element={<ProtectedRoute perm="warehouse_daily.view"><WarehouseDaily /></ProtectedRoute>} />
              <Route path="shift-oversight" element={<ProtectedRoute perm="shifts.manage"><ShiftOversight /></ProtectedRoute>} />
              <Route path="inpatients" element={<ProtectedRoute perm="inpatients.view"><Inpatients /></ProtectedRoute>} />
              <Route path="help" element={<ProtectedRoute perm="help.view"><Help /></ProtectedRoute>} />
              <Route path="near-expiry" element={<ProtectedRoute perm="near_expiry.view"><NearExpiry /></ProtectedRoute>} />
              <Route path="ledger" element={<ProtectedRoute perm="ledger.view"><Ledger /></ProtectedRoute>} />
              <Route path="suppliers" element={<ProtectedRoute perm="suppliers.view"><Suppliers /></ProtectedRoute>} />
              <Route path="procurement" element={<ProtectedRoute perm="procurement.view"><Procurement /></ProtectedRoute>} />
              <Route path="returns" element={<ProtectedRoute perm="procurement.returns"><Returns /></ProtectedRoute>} />
              <Route path="claims" element={<ProtectedRoute perm="finance.claims"><Claims /></ProtectedRoute>} />
              <Route path="schemes" element={<ProtectedRoute perm="schemes.view"><Schemes /></ProtectedRoute>} />
              <Route path="statements" element={<ProtectedRoute perm="finance.statements"><Statements /></ProtectedRoute>} />
              <Route path="deliveries" element={<ProtectedRoute perm="delivery.view"><Deliveries /></ProtectedRoute>} />
              <Route path="live-map" element={<ProtectedRoute perm="livemap.view"><LiveMapPage /></ProtectedRoute>} />
              <Route path="rider" element={<ProtectedRoute perm="delivery.rider"><RiderView /></ProtectedRoute>} />
              <Route path="prescriptions" element={<ProtectedRoute perm="prescriptions.view"><Prescriptions /></ProtectedRoute>} />
              <Route path="customers" element={<ProtectedRoute perm="customers.view"><Customers /></ProtectedRoute>} />
              <Route path="users" element={<ProtectedRoute perm="users.view"><Users /></ProtectedRoute>} />
              <Route path="branches" element={<ProtectedRoute perm="branches.manage"><Branches /></ProtectedRoute>} />
              <Route path="settings" element={<ProtectedRoute perm="settings.manage"><Settings /></ProtectedRoute>} />
              <Route path="audit" element={<ProtectedRoute perm="audit.view"><Audit /></ProtectedRoute>} />
              <Route path="wholesale" element={<ProtectedRoute anyPerm={["wholesale.view", "wholesale.orders", "wholesale.accounts", "wholesale.fulfil"]}><Wholesale /></ProtectedRoute>} />
              <Route path="wholesale-reports" element={<ProtectedRoute perm="wholesale.reports"><WholesaleReports /></ProtectedRoute>} />
            </Route>
          </Routes>
        </BranchProvider>
      </BrowserRouter>
    </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
